module.exports = __webpack_public_path__ + "static/banner-sm-d751a92cb401e5ec3d9fc7da41d0fa20.jpg";